import styled from 'styled-components'

export const Container = styled.div`
  height: 645px;
`

export const ContainerLoading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 90vh;
`
